<ion-header>

</ion-header>
<ion-content>
    <div flex-space-between>
        <div style="
        text-align: center;
        margin-top: 40%;
        transform: scale(1.5);" [hidden]="paidFor" #paypal></div>
    </div>

    <ion-card *ngIf="paymentSuccessful">
        <ion-label>
            thanks for purchase! Please come back to the application;
        </ion-label>
    </ion-card>

</ion-content>